export default "__VITE_PUBLIC_ASSET__5ee5c011__"